module.exports = __webpack_public_path__ + "img/mindespore.a0114410.svg";